export enum Method {
    Delete = 'DELETE',
    Get = 'GET',
    Head = 'HEAD',
    Patch = 'PATCH',
    Post = 'POST',
    Put = 'PUT',
}
